import useNavigator from "@saleor/hooks/useNavigator";
import useNotifier from "@saleor/hooks/useNotifier";
import useShop from "@saleor/hooks/useShop";
import { commonMessages } from "@saleor/intl";
import { stringify as stringifyQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";

import { maybe } from "../../misc";
import {
  LanguageCodeEnum,
  NameTranslationInput
} from "../../types/globalTypes";
import TranslationsProductTagPage, {
  fieldNames
} from "../components/TranslationsProductTagPage";
import { TypedUpdateProductTagTranslations } from "../mutations";
import { TypedProductTagTranslationDetails } from "../queries";
import { UpdateProductTagTranslations } from "../types/UpdateProductTagTranslations";
import {
  // languageEntitiesUrl,
  languageEntityUrl,
  TranslatableEntities
} from "../urls";

export interface TranslationsProductTagQueryParams {
  activeField: string;
}
export interface TranslationsProductTagProps {
  id: string;
  languageCode: LanguageCodeEnum;
  params: TranslationsProductTagQueryParams;
}

const TranslationsProductTag: React.FC<TranslationsProductTagProps> = ({
  id,
  languageCode,
  params
}) => {
  const navigate = useNavigator();
  const notify = useNotifier();
  const shop = useShop();
  const intl = useIntl();

  const onEdit = (field: string) =>
    navigate(
      "?" +
        stringifyQs({
          activeField: field
        }),
      true
    );
  const onUpdate = (data: UpdateProductTagTranslations) => {
    if (data.producttagsTranslate.errors.length === 0) {
      notify({
        status: "success",
        text: intl.formatMessage(commonMessages.savedChanges)
      });
      navigate("?", true);
    }
  };
  const onDiscard = () => {
    navigate("?", true);
  };

  return (
    <TypedProductTagTranslationDetails
      variables={{ id, language: languageCode }}
    >
      {productTagTranslations => (
        <TypedUpdateProductTagTranslations onCompleted={onUpdate}>
          {(updateTranslations, updateTranslationsOpts) => {
            const handleSubmit = (field: string, data: string) => {
              const input: NameTranslationInput = {};
              if (field === fieldNames.name) {
                input.name = data;
              }
              updateTranslations({
                variables: {
                  id,
                  input,
                  language: languageCode
                }
              });
            };

            return (
              <TranslationsProductTagPage
                activeField={params.activeField}
                disabled={
                  productTagTranslations.loading ||
                  updateTranslationsOpts.loading
                }
                languageCode={languageCode}
                languages={maybe(() => shop.languages, [])}
                saveButtonState={updateTranslationsOpts.status}
                onBack={() => history.go(-1)}
                onEdit={onEdit}
                onDiscard={onDiscard}
                onLanguageChange={lang =>
                  navigate(
                    languageEntityUrl(lang, TranslatableEntities.productTag, id)
                  )
                }
                onSubmit={handleSubmit}
                tag={maybe(() => productTagTranslations.data.producttag)}
              />
            );
          }}
        </TypedUpdateProductTagTranslations>
      )}
    </TypedProductTagTranslationDetails>
  );
};
TranslationsProductTag.displayName = "TranslationsProductTag";
export default TranslationsProductTag;
